import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

import { useAuthenticationContext } from '../../context';
import { useGetRequestOptions } from '../../hooks';

export type OrthancIdReqBody = {
  Level: 'Study'
  Query: {
    StudyInstanceUID: string
  }
}

export type LinkGenReqBody = {
  Resources: {
    OrthancId: string,
    DicomUid: string,
    Level: 'study'
  }[],
  Type: 'ohif-viewer-publication',
  ValidityDuration: number
}

export const useFindOrthancId = () => {
  const { authToken } = useAuthenticationContext();
  const options = useGetRequestOptions(authToken);

  return useMutation({
    mutationFn: (body: OrthancIdReqBody) =>
      axios.post("https://keycloakpacs.xylexa.ai/orthanc/tools/find", body, options),
  });
};


export const useGenerateStudyLink = () => {
  const { authToken } = useAuthenticationContext();
  const options = useGetRequestOptions(authToken);

  return useMutation({
    mutationFn: (body: LinkGenReqBody) =>
      axios.put("https://keycloakpacs.xylexa.ai/orthanc/auth/tokens/ohif-viewer-publication", body, options),
  });
};
